import React from 'react';
import { Outlet, Link, useNavigate, useLocation } from 'react-router-dom';
import { LayoutDashboard, Package, ShoppingBag, Settings, LogOut } from 'lucide-react';
import { Button } from '../../components/ui/button';

const AdminLayout = () => {
  const navigate = useNavigate();
  const location = useLocation();

  const handleLogout = () => {
    localStorage.removeItem('admin_token');
    navigate('/admin/login');
  };

  const isActive = (path) => location.pathname === path;

  return (
    <div className="min-h-screen bg-neutral-50">
      {/* Top Bar */}
      <div className="bg-white border-b">
        <div className="flex items-center justify-between px-8 py-4">
          <div className="flex items-center space-x-3">
            <div className="w-10 h-10 bg-neutral-900 rounded-full flex items-center justify-center">
              <span className="text-white font-light text-lg">F&C</span>
            </div>
            <div>
              <h1 className="text-xl font-light text-neutral-900">Freddy & Co.</h1>
              <p className="text-xs text-neutral-500">Admin Dashboard</p>
            </div>
          </div>
          <Button
            variant="outline"
            onClick={handleLogout}
            className="flex items-center space-x-2"
          >
            <LogOut className="w-4 h-4" />
            <span>Logout</span>
          </Button>
        </div>
      </div>

      <div className="flex">
        {/* Sidebar */}
        <div className="w-64 bg-white border-r min-h-[calc(100vh-73px)] p-4">
          <nav className="space-y-2">
            <Link to="/admin/dashboard">
              <Button
                variant={isActive('/admin/dashboard') ? 'secondary' : 'ghost'}
                className="w-full justify-start"
              >
                <LayoutDashboard className="w-4 h-4 mr-2" />
                Dashboard
              </Button>
            </Link>
            <Link to="/admin/products">
              <Button
                variant={isActive('/admin/products') ? 'secondary' : 'ghost'}
                className="w-full justify-start"
              >
                <Package className="w-4 h-4 mr-2" />
                Products
              </Button>
            </Link>
            <Link to="/admin/orders">
              <Button
                variant={isActive('/admin/orders') ? 'secondary' : 'ghost'}
                className="w-full justify-start"
              >
                <ShoppingBag className="w-4 h-4 mr-2" />
                Orders
              </Button>
            </Link>
            <Link to="/admin/settings">
              <Button
                variant={isActive('/admin/settings') ? 'secondary' : 'ghost'}
                className="w-full justify-start"
              >
                <Settings className="w-4 h-4 mr-2" />
                Settings
              </Button>
            </Link>
          </nav>
        </div>

        {/* Main Content */}
        <div className="flex-1 p-8">
          <Outlet />
        </div>
      </div>
    </div>
  );
};

export default AdminLayout;